import { BaseItem, NullablePartial } from '../../common';
import { Preferences } from '../../practice/preference';
import * as PluginConfiguration from './pluginConfiguration';

export enum AvailableIcon {
  Activity = 'ACTIVITY',
  Alert = 'ALERT',
  Archive = 'ARCHIVE',
  Award = 'AWARD',
  Book = 'BOOK',
  Calendar = 'CALENDAR',
  Clipboard = 'CLIPBOARD',
  Chat = 'CHAT',
  Check = 'CHECK',
  Clock = 'CLOCK',
  CreditCard = 'CREDIT_CARD',
  Edit = 'EDIT',
  File = 'FILE',
  Flag = 'FLAG',
  Folder = 'FOLDER',
  Gift = 'GIFT',
  Heart = 'HEART',
  Help = 'HELP',
  Home = 'HOME',
  Info = 'INFO',
  Insurance = 'INSURANCE',
  Link = 'LINK',
  Location = 'LOCATION',
  Lock = 'LOCK',
  Payment = 'PAYMENT',
  People = 'PEOPLE',
  Person = 'PERSON',
  Phone = 'PHONE',
  Referral = 'REFERRAL',
  Smile = 'SMILE',
  Star = 'STAR',
  Watch = 'WATCH',
}

export interface BaseConfiguration {
  organizationId: string;
  name: string | null;
  crawlerConfigId: string | null;

  // content
  careTeamName: string | null;
  greetingMessage: string | null;
  promptQuestions: string[] | null;
  inputTextHeroPlaceholder: string | null;
  inputTextMainPagePlaceholder: string | null;
  inputHelperText: string | null;
  takeoverButtonTokenToPromptMapping: Record<string, string> | null;
  heroCommonQuestionsHeader: string | null;

  // tone
  toneAttributes: string[] | null;

  // typography
  fontFamily: string | null;
  paragraphFontFamily: string | null;
  heroGreetingMessageFontFamily: string | null;
  heroGreetingMessageFontSizeDesktop: string | null;
  heroGreetingMessageFontSizeMobile: string | null;
  heroGreetingMessageFontWeight: string | null;
  heroInputFontFamily: string | null;
  heroInputFontSizeDesktop: string | null;
  heroInputFontSizeMobile: string | null;
  conversationFontFamily: string | null;
  conversationFontSizeDesktop: string | null;
  conversationFontSizeMobile: string | null;
  fontSize: string | null;
  fontColor: string | null;
  eyebrowContent: string | null;
  eyebrowFontFamily: string | null;
  eyebrowFontSizeDesktop: string | null;
  eyebrowFontSizeMobile: string | null;

  // color
  actionColor: string | null;
  backgroundColor: string | null;
  borderColor: string | null;
  heroCommonQuestionBackgroundColor: string | null;
  heroCommonQuestionIconColor: string | null;
  heroCommonQuestionTextColor: string | null;
  heroCommonQuestionsHeaderColor: string | null;
  heroGradientOneColor: string | null;
  heroGradientTwoColor: string | null;
  heroGreetingMessageColor: string | null;
  inputHelperTextColor: string | null;
  transparentHeroBackgroundEnabled?: boolean;

  // sso
  ssoAuthEnabled: boolean | null;
  ssoAuthButtonIcon: AvailableIcon | null;
  ssoAuthButtonLabel: string | null;

  // icon
  iconConversationUrl: string | null;

  // corner radius
  inputBorderRadiusPx: string | null;
  buttonBorderRadiusPx: string | null;

  // scope
  authenticationEnabled: boolean | null;
  configurationFromPracticeId?: string | null;
}

export type UpsertValues = NullablePartial<BaseConfiguration>;

export interface UpsertValuesWithPluginConfigs
  extends Omit<UpsertValues, 'organizationId'> {
  pluginOptions?: Omit<
    PluginConfiguration.UpsertValues,
    'assistantConfigurationId'
  >[];
}

export interface Configuration extends BaseConfiguration, BaseItem {}

export interface ConfigurationWithPluginConfigs extends Configuration {
  pluginOptions?: PluginConfiguration.UpsertValues[];
  previsitDomain: string | null;
}

export type ConfigurationWithSession = Configuration &
  Pick<Preferences, 'previsitUseNotionalSchedulingTimeSlots'> & {
    sessionId: string;
    ssoEnabled: boolean;
    authenticationEnabled: boolean;
  };
